import React, { useEffect, useRef } from 'react';
import { Redirect } from 'react-router-dom';
import classNames from 'classnames';
// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles';
import MenuItem from '@material-ui/core/MenuItem';
import MenuList from '@material-ui/core/MenuList';
import Grow from '@material-ui/core/Grow';
import Paper from '@material-ui/core/Paper';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Hidden from '@material-ui/core/Hidden';
import Poppers from '@material-ui/core/Popper';
// @material-ui/icons
import Person from '@material-ui/icons/Person';
import Notifications from '@material-ui/icons/Notifications';
// core components
import Button from 'components/CustomButtons/Button';
import { Button as ButtonPrime } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { FaSpinner } from 'react-icons/fa';
import { Dialog } from 'primereact/dialog';
import { Toast } from 'primereact/toast';

import styles from 'assets/jss/material-dashboard-react/components/headerLinksStyle';

import { set } from 'date-fns';
import * as ambiente from '../../config/database';
import { dominioBackend } from '../../config/database';

const useStyles = makeStyles(styles);

export default function AdminNavbarLinks() {
  const classes = useStyles();
  const [openNotification, setOpenNotification] = React.useState(null);
  const [openProfile, setOpenProfile] = React.useState(null);
  const [redirecionaLogout, setLogout] = React.useState(false);
  const [totalPendente, setTotalPendente] = React.useState(0);
  const [notificacoes, setNotificacoes] = React.useState([]);
  const [abreAlterarSenha, setAbreAlterarSenha] = React.useState(false);
  const [senhaAntiga, setSenhaAntiga] = React.useState('');
  const [novaSenha, setNovaSenha] = React.useState('');
  const [confirmaNovaSenha, setConfirmaNovaSenha] = React.useState('');
  const [loading, setLoading] = React.useState(false);

  const myToast = useRef(null);

  const profissional = JSON.parse(localStorage.getItem('profissional'));

  const handleLogout = async () => {
    setLogout(true);
  };

  function handleNotificacoes() {
    ambiente.dominioLog.get(`/listarNotificacao/${profissional.userId}`).then(res => {
      setNotificacoes(res.data);
    });

    ambiente.dominioLog.get(`/quantidadeNotificacaoNaoLida/${profissional.userId}`).then(res => {
      setTotalPendente(res.data);
    });
  }

  function lerNotificacoes() {
    ambiente.dominioLog.put(`/lerNotificacao/${profissional.userId}`).then(() => {
      handleNotificacoes();
    });
  }

  // useEffect(() => {
  //   handleNotificacoes();
  //   const interval = setInterval(() => {
  //     handleNotificacoes();
  //   }, 360000);
  //   return () => clearInterval(interval);
  // }, []);

  const handleClickNotification = event => {
    lerNotificacoes();
    if (openNotification && openNotification.contains(event.target)) {
      setOpenNotification(null);
    } else {
      setOpenNotification(event.currentTarget);
    }
  };
  const handleCloseNotification = () => {
    setOpenNotification(null);
  };
  const handleClickProfile = event => {
    if (openProfile && openProfile.contains(event.target)) {
      setOpenProfile(null);
    } else {
      setOpenProfile(event.currentTarget);
    }
  };
  const handleCloseProfile = () => {
    setOpenProfile(null);
  };

  if (redirecionaLogout) {
    localStorage.clear();
    return <Redirect from="/" to="/login" />;
  }

  const handleAlterarSenha = () => {
    if (senhaAntiga.length < 4 || novaSenha.length < 4 || confirmaNovaSenha.length < 4) {
      alert('As senhas devem ter no mínimo 4 caracteres.');
      return;
    }
    if (novaSenha !== confirmaNovaSenha) {
      alert('A nova senha e a confirmação da nova senha não coincidem.');
      return;
    }

    const body = {
      old_password: senhaAntiga,
      new_password: novaSenha,
    };

    dominioBackend
      .post('/api/alterarSenha', body)
      .then(res => {
        setAbreAlterarSenha(true);
        myToast.current.show({
          severity: 'success',
          summary: 'Sucesso!',
          detail: 'Senha alterada com sucesso!',
          life: '3000',
        });
        setAbreAlterarSenha(false);
        setSenhaAntiga('');
        setNovaSenha('');
        setConfirmaNovaSenha('');
      })
      .catch(() => {
        myToast.current.show({
          severity: 'error',
          summary: 'Erro!',
          detail: 'Erro ao alterar a senha. Verifique se a senha antiga está correta.',
          life: '3000',
        });
      });
  };

  return (
    <div id="barra-superior">
      <Toast ref={myToast} />
      <Dialog
        header="Alterar Senha"
        style={{ width: '30vw' }}
        visible={abreAlterarSenha}
        onHide={() => setAbreAlterarSenha(false)}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            gap: '24px',
          }}
        >
          <div style={{ height: '1px', width: '100%', backgroundColor: '#4e4e4eff' }} />
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              width: '100%',
            }}
          >
            <label htmlFor="senhaAntiga">Senha Antiga</label>
            <InputText
              id="senhaAntiga"
              type="text"
              maxLength={50}
              defaultValue={senhaAntiga}
              onInput={e => setSenhaAntiga(e.target.value)}
              style={{ width: '50%', borderRadius: 8 }}
            />
          </div>

          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              width: '100%',
            }}
          >
            <label htmlFor="novaSenha">Nova Senha</label>
            <InputText
              id="novaSenha"
              type="text"
              maxLength={50}
              defaultValue={novaSenha}
              onInput={e => setNovaSenha(e.target.value)}
              style={{ width: '50%', borderRadius: 8 }}
            />
          </div>

          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              width: '100%',
            }}
          >
            <label htmlFor="confirmaNovaSenha">Confirma Nova Senha</label>
            <InputText
              id="confirmaNovaSenha"
              type="text"
              maxLength={50}
              defaultValue={confirmaNovaSenha}
              onInput={e => setConfirmaNovaSenha(e.target.value)}
              style={{ width: '50%', borderRadius: 8 }}
            />
          </div>

          <div style={{ display: 'flex', justifyContent: 'center', width: '100%', gap: '8px' }}>
            <ButtonPrime
              type="button"
              style={{
                display: 'block',
                width: '40%',
                backgroundColor: 'transparent',
                color: '#2196F3',
              }}
              onClick={() => setAbreAlterarSenha(false)}
            >
              CANCELAR
            </ButtonPrime>
            <ButtonPrime
              type="button"
              style={{ display: 'block', width: '40%' }}
              onClick={() => handleAlterarSenha()}
            >
              SALVAR
            </ButtonPrime>
          </div>
        </div>
      </Dialog>

      <div className={classes.manager}>
        <Button
          color={window.innerWidth > 959 ? 'transparent' : 'white'}
          justIcon={window.innerWidth > 959}
          simple={!(window.innerWidth > 959)}
          aria-owns={openNotification ? 'notification-menu-list-grow' : null}
          aria-haspopup="true"
          onClick={handleClickNotification}
          className={classes.buttonLink}
        >
          <Notifications className={classes.icons} style={{ zIndex: 100 }} />
          <span className={classes.notifications}>{totalPendente}</span>
          <Hidden mdUp implementation="css" />
        </Button>

        <Poppers
          open={Boolean(openNotification)}
          anchorEl={openNotification}
          transition
          disablePortal
          className={`${classNames({ [classes.popperClose]: !openNotification })} ${classes.popperNav
            }`}
        >
          {({ TransitionProps, placement }) => (
            <Grow
              {...TransitionProps}
              id="notification-menu-list-grow"
              style={{
                transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom',
              }}
            >
              <Paper style={{ maxHeight: '50vh', overflow: 'auto', zIndex: 10000 }}>
                <ClickAwayListener onClickAway={handleCloseNotification}>
                  <MenuList role="menu">
                    {notificacoes.map(notify => (
                      <MenuItem
                        key={notify.id}
                        onClick={handleCloseNotification}
                        className={classes.dropdownItem}
                      >
                        <strong>
                          <span>{` ${notify.descricao}`}</span>
                        </strong>
                      </MenuItem>
                    ))}
                  </MenuList>
                </ClickAwayListener>
              </Paper>
            </Grow>
          )}
        </Poppers>
      </div>
      <div className={classes.manager}>
        <Button
          color={window.innerWidth > 959 ? 'transparent' : 'white'}
          justIcon={window.innerWidth > 959}
          simple={!(window.innerWidth > 959)}
          aria-owns={openProfile ? 'profile-menu-list-grow' : null}
          aria-haspopup="true"
          onClick={handleClickProfile}
          className={classes.buttonLink}
        >
          <Person className={classes.icons} />
          <Hidden mdUp implementation="css">
            <p className={classes.linkText}>Perfil</p>
          </Hidden>
        </Button>
        <Poppers
          open={Boolean(openProfile)}
          anchorEl={openProfile}
          transition
          disablePortal
          className={`${classNames({ [classes.popperClose]: !openProfile })} ${classes.popperNav}`}
        >
          {({ TransitionProps, placement }) => (
            <Grow
              {...TransitionProps}
              id="profile-menu-list-grow"
              style={{
                transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom',
              }}
            >
              <Paper>
                <ClickAwayListener onClickAway={handleCloseProfile}>
                  <MenuList role="menu">
                    <MenuItem onClick={handleLogout} className={classes.dropdownItem}>
                      Sair
                    </MenuItem>
                    <MenuItem
                      onClick={() => setAbreAlterarSenha(true)}
                      className={classes.dropdownItem}
                    >
                      Alterar Senha
                    </MenuItem>
                  </MenuList>
                </ClickAwayListener>
              </Paper>
            </Grow>
          )}
        </Poppers>
      </div>
    </div>
  );
}
